/**
 * Adaptive role dashboard — every staff user now lands on "/", where the
 * dashboard engine assembles the recipe for their primary role (or their
 * persisted "Viewing as" choice). The old per-role landing routes
 * (/dashboard/liaison, /dashboard/loan-admin, /dashboard/manager) are
 * retired and redirect here.
 */
export function getDefaultRouteForUser(_user: {
  roleCodes?: readonly string[];
} | null | undefined): string {
  return "/";
}
